import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import aiTrainingService, { 
  CreateTrainingDataRequest, 
  UpdateTrainingDataRequest,
  CreateRevisionRequest 
} from '@/services/ai-training.service';

// Training Data hooks
export function useTrainingData(params?: {
  page?: number;
  limit?: number;
  category?: string;
  is_active?: string;
  organizationId?: string;
}) {
  return useQuery({
    queryKey: ['ai-training-data', params],
    queryFn: () => aiTrainingService.getTrainingData(params),
  });
}

export function useCreateTrainingData() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: CreateTrainingDataRequest) => 
      aiTrainingService.createTrainingData(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ai-training-data'] });
    },
  });
}

export function useUpdateTrainingData() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateTrainingDataRequest }) => 
      aiTrainingService.updateTrainingData(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ai-training-data'] });
    },
  });
}

export function useDeleteTrainingData() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id: string) => aiTrainingService.deleteTrainingData(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ai-training-data'] });
    },
  });
}

// Response Revision hooks
export function useResponseRevisions(params?: {
  page?: number;
  limit?: number;
  ticket_id?: string;
  status?: string;
}) {
  return useQuery({
    queryKey: ['ai-response-revisions', params],
    queryFn: () => aiTrainingService.getRevisions(params),
  });
}

export function useCreateRevision() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: CreateRevisionRequest) => 
      aiTrainingService.createRevision(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ai-response-revisions'] });
    },
  });
}

// Helper hooks
export function useAICategories() {
  return aiTrainingService.getCategories();
}